import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { darkTheme as theme } from '../App/Config/theme';
import LoginBody from './Components/Login/LoginBody';
import RegisterBody from './Components/Register/RegisterBody';
import SentEmailBody from './Components/Confirm/SentEmailBody';
import ForgotPasswordBody from './Components/ForgotPassword/ForgotPasswordBody';
import ResetPasswordBody from './Components/ResetPassword/ResetPasswordBody';
import SendConfirmationInstructionsBody from './Components/Unlock/SendConfirmationInstructionsBody';
import Header from './Components/Header';

class AuthLogin extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            confirmEmail: this.props.confirmEmail || ''
        };
    }

    render () {
        const { flash } = this.props;
        const { confirmEmail } = this.state;
        let message;
        if (flash && flash[0] && flash[0][0] === 'notice' && flash[0][1] !== 'Signed out successfully.') {
            message = flash[0][1];
        }
        return (
            <ThemeProvider theme={theme}>
                <Header />
                <Router>
                    <Switch>
                        <Route path="/user/login">
                            <LoginBody setConfirmEmail={(v) => this.setState({ confirmEmail: v })} message={message || ''} />
                        </Route>
                        <Route path="/user/sign_up">
                            <RegisterBody setConfirmEmail={(v) => this.setState({ confirmEmail: v })} />
                        </Route>
                        <Route path="/user/confirmation_sent">
                            <SentEmailBody confirmEmail={confirmEmail} setConfirmEmail={(v) => this.setState({ confirmEmail: v })} />
                        </Route>
                        <Route path="/user/password/new">
                            <ForgotPasswordBody />
                        </Route>
                        <Route path="/user/password/edit">
                            <ResetPasswordBody />
                        </Route>
                        <Route path="/user/unlock/new">
                            <SendConfirmationInstructionsBody />
                        </Route>
                    </Switch>
                </Router>
            </ThemeProvider>
        );
    }
}

export default AuthLogin;